export default __webpack_public_path__ + "static/media/novoville_logo.d24d16c8.svg";